module.exports = __webpack_public_path__ + "img/new_strategies_icon.27106bb5.svg";